<template>
  <div id="footer">
    <br><br>
    <h1 CLASS="footer-title">STANCIJA KATARINA DI MALADEL</h1>
    <div class="footer-content">
        <h3 class="contact-us-text">CONTACT US</h3>
        <div class="info-section text-left">
            <div style="display: inline-block;">
            </div>
            <div class="location-info">
            <div class="location">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="smaller-svg bi bi-geo-alt-fill" viewBox="0 0 16 16">
                    <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6"/>
                </svg>
                <p class="contact-info" style="margin-bottom:10px">Segetska ul., 52470, Finida</p>
            </div>
            <div class="phone">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="smaller-svg bi bi-phone" viewBox="0 0 16 16">
                    <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                    <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>
                </svg>
                <p class="contact-info">+385 91 363 1111</p>
            </div>
            <div class="email">
                <svg class="smaller-svg" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383l-4.758 2.855L15 11.114v-5.73zm-.034 6.878L9.271 8.82 8 9.583 6.728 8.82l-5.694 3.44A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.739zM1 11.114l4.758-2.876L1 5.383v5.73z"/>
                        </svg>
                <p class="contact-info">stancija.katarina.cabrunici@gmail.com</p>
            </div>
            <ul class="social-media-icons">
                <li>
                    <a href="https://www.facebook.com/Stancija-Katarina-di-Maladel-352455715846420/" target="_blank">
                        <svg class="smaller-svg" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"/>
                        </svg>
                    </a>
                </li>
                <li>
                    <a href="https://www.instagram.com/katarina_di_maladel?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank">
                        <svg class="smaller-svg" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"/>
                        </svg>
                    </a>
                </li>
                <li>
                    <a href="mailto:info@stancija-katarina.com" target="_blank">
                        <svg class="smaller-svg" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383l-4.758 2.855L15 11.114v-5.73zm-.034 6.878L9.271 8.82 8 9.583 6.728 8.82l-5.694 3.44A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.739zM1 11.114l4.758-2.876L1 5.383v5.73z"/>
                        </svg>
                    </a>
                </li>
            </ul>
        </div>
            
            
        <div class="brochure">
            <h3 class="view-brochure-footer-text">View our brochure</h3>
            <br>
            <a href="https://www.calameo.com/read/007571348abbe1831d760" target="_blank">
            <!--<button @click="downloadPdf" style="background-color: transparent; border: none;">-->
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="pdf-svg bi bi-file-pdf" viewBox="0 0 16 16">
                    <path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1"/>
                    <path d="M4.603 12.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.187-.012.395-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.065.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.6 11.6 0 0 0-1.997.406 11.3 11.3 0 0 1-1.021 1.51c-.29.35-.608.655-.926.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.244.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 5.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z"/>
                </svg>
            <!--</button>-->
            </a>
        </div>
        </div>
        
    <div class="brochure-section">
        
        <div class="special-offer">
            <p style="color: white">Explore our second villa; Stancija Čabrunići and book with special discount</p><br>
        
            <div class="website">
                <div style="display: inline-flex"><svg style="color:white; margin-bottom:5px" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-globe" viewBox="0 0 16 16">
                    <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855A8 8 0 0 0 5.145 4H7.5zM4.09 4a9.3 9.3 0 0 1 .64-1.539 7 7 0 0 1 .597-.933A7.03 7.03 0 0 0 2.255 4zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a7 7 0 0 0-.656 2.5zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5zM8.5 5v2.5h2.99a12.5 12.5 0 0 0-.337-2.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5zM5.145 12q.208.58.468 1.068c.552 1.035 1.218 1.65 1.887 1.855V12zm.182 2.472a7 7 0 0 1-.597-.933A9.3 9.3 0 0 1 4.09 12H2.255a7 7 0 0 0 3.072 2.472M3.82 11a13.7 13.7 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5zm6.853 3.472A7 7 0 0 0 13.745 12H11.91a9.3 9.3 0 0 1-.64 1.539 7 7 0 0 1-.597.933M8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855q.26-.487.468-1.068zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.7 13.7 0 0 1-.312 2.5m2.802-3.5a7 7 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7 7 0 0 0-3.072-2.472c.218.284.418.598.597.933M10.855 4a8 8 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4z"/>
                </svg><a style="margin-left:5px" href="https://stancijacabrunici.hr">www.stancijacabrunici.hr</a></div>
            </div>
        </div>
    </div>
    </div>  
    <div>
        <a href="https://www.google.com/maps/place/Stancija+Katarina+di+Maladel/@45.4216012,13.5399621,17z/data=!3m1!4b1!4m6!3m5!1s0x477b63f203af8b31:0x13fd7facac1c4096!8m2!3d45.4215975!4d13.542537!16s%2Fg%2F11m9qkrtsh?entry=ttu" target="_blank">
            <img src="../assets/images/katarina_karta.png" style="width:500px; height:448px" class="katarina-image">
        </a>
    </div>
    <div class="copyright-section">
      <p>© Istra Vacation travel agency by DAH Istra d.o.o.</p>
      <!--<span>Custom by <a href="#"><i>H.3 Solutions</i></a></span>-->
    </div>
  </div>
</template>

<script>
import DownloadPdfButton from '@/components/DownloadPdfButton.vue';
export default {
    name: "Footer",
    props: {
        webDataGlobal: {
            type: Object,
            required: true
        }
    },
    components: {
        DownloadPdfButton
    },
    data () {
        return {
            webData: {},
            pdfUrl: "@/assets/pdf/preuzmi.pdf",
            pdfFileName: 'Katarina_di_Maladel_Booklet.pdf'
        }
    },
    created () {
        /*this.webData = this.webDataGlobal.acc;
        document.addEventListener("DOMContentLoaded", function() {
        var pdfLink = document.getElementById("pdfLink");

        pdfLink.addEventListener("click", function(event) {
            // Postavite putanju do vašeg PDF fajla
            var pdfPath = "../assets/pdf/Katarina_di_Maladel_Booklet.pdf";

            // Postavite "href" atribut na željenu putanju
            pdfLink.href = pdfPath;
        });
    })*/ 
    }
}
</script>

<style scoped>
#footer {
  position: relative;
  width: 100%;
  background-color: rgb(148,172,173);
}
.info-section, .copyright-section {
  width: 100%;
  display: block;
}

.view-brochure-footer-text {
    color: white;
    font-size: 20px;
}

@media (min-width: 576px)
{
    .info-section {
        padding: 1rem 1.5rem;
    }
}

.info-section {
    position: relative;
    display: flex !important;
    display: block;
    justify-content: center; /* Centriranje horizontalno */
    align-items: center; /* Centriranje vertikalno */
    padding: 1rem 1.5rem;
}
.info-section div h3 {
    line-height: 30px;
    margin: 0;
    cursor: pointer;
}
.info-section h3:hover {
    text-decoration: underline;
}
.info-section ul {
    list-style-type: none;
    display: flex;
    justify-content: left; /* Centriranje horizontalno unutar <ul> */
    margin: 0;
}
.contact-us-text {
    /*margin-left: 33rem; */
    margin-top: 10px;
    text-align: center;
}
ul {
    padding-inline-start: 0px;
}
.info-section ul li {
    display: inline-block;

}
.info-section ul li a {
    font-size: 18px;
    color: white;
}
.info-section ul li a:hover {
    color: black!important;
}

.info-section ul li svg {
    margin-right: 5px;
}
.copyright-section {
  position: relative;
  padding: 5px 0 0;
  color: #ffffff;
  background-color: rgb(148,172,173);
  overflow: hidden;
}
.copyright-section p {
    width: 100%;
    text-align: center;
    color: #f7f7f7;
}
.copyright-section p, .copyright-section span {
  display: inline-block;
  margin: 0;
}
.copyright-section span {
  position: absolute;
  top: 5px;
  right: 12px;
}
.copyright-section a {
  color: #ffffff;
}
.footer-title {
    color:white;
    /*margin-left:70px;*/
    text-align: center;
}

.location-info {
    display: inline-block;
    margin-right: 200px;
    /* justify-content: space-around; */
    /* padding: 10px 201px; */
}

.smaller-svg {
    width: 32px;
    height: 32px;
}

.pdf-svg {
    width: 120px;
    height: 120px;
    color: white;
}

.pdf-svg:hover {
    color: black;
}

.website a:hover {
    color: black !important;
}

.info-section h3:hover {
    /*color: black;*/
    text-decoration: none;
    cursor: text;
}

.location, .phone, .email {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
}

.location svg, .phone svg, .email svg {
    margin-right: 5px;
}
.footer-content {
    color:white !important;
    /*border-style: solid;
    border-width: 2.5px;*/
    margin:2rem;
    margin-left: 400px;
    /*margin-right: 270px;*/
    padding-top: 40px;
    padding-bottom: 40px;
}
.contact-info {
    color: white;
    margin-bottom: 0rem !important;
}

.brochure {
    text-align: center;
}
.brochure-section {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: center;
    /*border-bottom: solid white;*/
}

.katarina-image {
    max-width: 100%;
    position: absolute;
    top: 30%;
    left: 20px;
    border-right: solid white;

}

.brochure, .special-offer {
    padding: 10px;
    /*border: 2px solid white;*/
    margin-right: 40px;
    margin-left: 70px;
    padding-top: 37px;
    padding-bottom: 37px;
    padding-left: 40px;
    padding-right: 40px;
}

.special-offer { 
    padding-top: 58px;
    padding-bottom: 58px;
    margin-left: 0px !important;
}

.brochure p,
.special-offer p {
    margin: 0;
}

.website a {
    color: white;
    text-decoration: none;
}

@media only screen and (min-width: 1281px) and (max-width: 1500px) {
    .location-info {
        margin-right: 0px !important;
    }
}

@media only screen and (min-width: 769px) and (max-width: 960px) {
    .katarina-image {
        width: 350px !important;
        height: 470px !important;
    }
    .footer-content {
        margin-right: -158px !important;
    }
}


@media (max-width: 768px){
    .footer-content{
        margin-left: 0%;
        margin-right: 0%;
        margin: 20px;
        padding-top: 0px;
        padding-bottom: 0px;
    } 
    .smaller-svg {
        width: 25px !important;
        height: 25px !important;
        margin-right: 0px !important;
    }  
    .info-section ul li {
        margin-right: 20px;
        margin-left: 30px;
    }
    .footer-title {
        font-size: 30px !important;
        margin-left: 5px;
        margin-right: 5px;
    }
    .info-section ul {
        justify-content: center;
    }
    .info-section {
        display: block !important;
        justify-content: right;
        align-items: center;
        padding: 0px;
        text-align: center !important;
    }
    .brochure-section {
        display: block;
        margin: 20px;
        text-align: center;
    }
    .brochure,
    .special-offer,
    .website {
        margin: 10px auto; 
    }
    .website a {
        font-size: 10px;
    }
    .location-info {
        margin-right: 0px;
        margin-top: 30px;
    }
    .katarina-image {
        max-width: 100%;
        position: relative;
        top: 0%;
    }
    .special-offer { 
        padding-top: 0px;
        padding-bottom: 0px;
        margin-left: 0px !important;
    }
    .brochure {
        padding-top: 45px !important;
        padding-bottom: 20px !important;
    }
    .phone, .email {
        margin-top: 30px !important;
    }
    .location, .phone, .email {
        justify-content: center;
    }
    .contact-us-text {
        margin-left: 0rem; 
        margin-top: 65px;
        font-size: 25px !important;
        text-align: center;
    }
    .social-media-icons {
        margin-top: 30px !important;
    }
    .contact-info {
        margin-left: 4px;
    }

}


@media only screen and (min-width: 768px) and (max-width: 1280px) {
    .footer-title {
        margin-left: 15px;
        margin-right: 15px;
    }
    .info-section ul {
        position: relative;
        justify-content: center;
    }
    .info-section ul li {
        margin: auto;
    }
    .info-section {
        justify-content: center;
        display: inline-grid !important;
        padding-bottom: 0px;
    }
    .location-info {
        margin-right: 10px;
    }
    .footer-content {
        margin-left: 250px;
        margin-right: -350px;
    }
    .brochure-section {
        justify-content: left;
        margin-left: 0px;
    }
    .location, .phone, .email {
        justify-content: center;
    }
    .brochure {
        margin-left: 30px;
    }
    .contact-us-text {
        margin-left: 0rem; 
        text-align: center;
    }
    .special-offer {
        display: none;
        margin-top: 30px;
    }
    .brochure-section {
        border-bottom: none;
    }
}

@media only screen and (min-width: 1280px) and (max-width: 1700px) {
    .footer-content {
        margin-left: 250px;
        margin-right: -350px;
    }
    .info-section[data-v-48940fdc] {
        justify-content: center;
    }
    .brochure-section {
        margin-left: 0px;
        justify-content: center;
    }
    .contact-us-text {
        margin-left: 0rem; 
        text-align: center;
    }
}

@media (min-width: 1700px) {
    .contact-us-text {
        /*margin-left: 23rem;*/
        margin-left: -100px;
    }
    .special-offer {
        margin-right: 125px;
    }

    .info-section, .contact-us-text {
        margin-left: 100px !important;
    }

    .special-offer {
        margin-left: 250px !important;
    }
}

</style>
